export default __webpack_public_path__ + "static/media/gov.8680afa3.png";